import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 4.75H20M4 19.25H20" vectorEffect="non-scaling-stroke" />
		<Path d="M4.75 9.75C4.75 9.19772 5.19772 8.75 5.75 8.75H18.25C18.8023 8.75 19.25 9.19772 19.25 9.75V14.25C19.25 14.8023 18.8023 15.25 18.25 15.25H5.75C5.19771 15.25 4.75 14.8023 4.75 14.25V9.75Z" vectorEffect="non-scaling-stroke" />
	</SVG>
);
